// Firebase config
/******************

   TEXT TRANSLATIONS

*******************/

var translations = function(key, language, text_vars=[]) {

  let all_translations = {

    qr_prompt: {
      en: `Scan this QR code with your phone to begin your survey on WhatsApp`,
      es: `Scan this QR code with your phone to begin your survey on WhatsApp`,
      bh: `Scan this QR code with your phone to begin your survey on WhatsApp`,
      ms: `Scan this QR code with your phone to begin your survey on WhatsApp`,
      hi: `Scan this QR code with your phone to begin your survey on WhatsApp`,
      pt: `Scan this QR code with your phone to begin your survey on WhatsApp`,
      vi: `Scan this QR code with your phone to begin your survey on WhatsApp`,
      ar: `Scan this QR code with your phone to begin your survey on WhatsApp`,
      ax: `Scan this QR code with your phone to begin your survey on WhatsApp`, // arabic formal
    }
  };


  let translations = all_translations[key];
  if (translations) {
    let text = translations[language];
    console.log({ translations });
    if (text) {
      return text;
    } else {
      console.log(`No text for key: ${key} and language: ${language}`);
      return translations[`en`];
    };
  } else {
    console.log(`No translations for key: ${key}`);  // This should never happen..
  };

  return ``;

};

export { translations };
